// Reviewed/Pending vocabulary and tallies, kept free of React so the planning process can share them.

export const REVIEWED_LABEL = "Reviewed"
export const PENDING_LABEL = "Pending"
export const RESET_REVIEWS_LABEL = "Reset reviewed state"

export type VariantReview = { reviewedAt: Date; reviewedBy: string | null }

export type ReviewTally = { reviewed: number; total: number }

export function tallyReviews(
  variantIds: readonly string[],
  reviews: ReadonlyMap<string, VariantReview>,
): ReviewTally {
  return {
    reviewed: variantIds.filter((id) => reviews.has(id)).length,
    total: variantIds.length,
  }
}

/** "all" / "none" / "mixed" over a selection; an empty selection reads as "none". */
export function reviewState(tally: ReviewTally): "all" | "none" | "mixed" {
  if (tally.total > 0 && tally.reviewed === tally.total) return "all"
  if (tally.reviewed === 0) return "none"
  return "mixed"
}

export const reviewedPercent = (tally: ReviewTally) =>
  tally.total === 0 ? 0 : Math.round((tally.reviewed / tally.total) * 100)
